export class HRConfigRight {
  hrConfigId:        string;
  employeeId:        string;
  rightName:         string;
  readAccess:        boolean = false;
  writeAccess:       boolean = false;
  deleteAccess:      boolean = false;
}
